<template>
  <div class="store-performance">
    <div class="page-header">
      <h2>门店业绩统计</h2>
      <p>查看门店净营业额统计数据</p>
    </div>
    
    <div class="page-content">
      <!-- 搜索区域 -->
      <div class="search-section">
        <div class="search-box">
          <select v-model="searchYear" class="year-select">
            <option value="2024">2024年</option>
            <option value="2025">2025年</option>
            <option value="2026">2026年</option>
          </select>
          <button @click="handleSearch" class="search-btn">查询</button>
          <button @click="handleReset" class="reset-btn">重置</button>
          <button @click="handleExport" class="export-btn">导出</button>
        </div>
      </div>

      <!-- 表格区域 -->
      <div class="table-section">
        <div class="table-header">
          <h3>门店业绩统计列表</h3>
        </div>
        
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>门店名称</th>
                <th>门店编码</th>
                <th>1月</th>
                <th>2月</th>
                <th>3月</th>
                <th>4月</th>
                <th>5月</th>
                <th>6月</th>
                <th>7月</th>
                <th>8月</th>
                <th>9月</th>
                <th>10月</th>
                <th>11月</th>
                <th>12月</th>
                <th>净营业额总计</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading" class="loading-row">
                <td colspan="15" class="loading-cell">
                  <div class="loading-spinner">
                    <div class="spinner"></div>
                  </div>
                </td>
              </tr>
              <tr v-else-if="!performanceList || performanceList.length === 0" class="empty-row">
                <td colspan="15" class="empty-cell">暂无数据</td>
              </tr>
              <tr v-else v-for="item in performanceList" :key="item.storeId" class="data-row">
                <td>{{ item.storeName }}</td>
                <td>{{ item.storeCode }}</td>
                <td class="amount-cell">{{ formatAmount(item.januaryAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.februaryAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.marchAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.aprilAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.mayAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.juneAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.julyAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.augustAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.septemberAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.octoberAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.novemberAmount) }}元</td>
                <td class="amount-cell">{{ formatAmount(item.decemberAmount) }}元</td>
                <td class="total-amount-cell">{{ formatAmount(item.totalAmount) }}元</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'StorePerformance',
  data() {
    return {
      performanceList: [],
      loading: false,
      searchYear: '2025'
    }
  },
  mounted() {
    this.loadPerformanceData()
  },
  methods: {
    async loadPerformanceData() {
      this.loading = true
      try {
        const response = await request.get('/api/consumption/monthlyStats', {
          params: {
            year: this.searchYear
          }
        })
        
        if (response.data.success && response.data.code === 200) {
          this.performanceList = response.data.data || []
        } else {
          throw new Error(response.data.message || '获取门店业绩统计失败')
        }
      } catch (error) {
        console.error('获取门店业绩统计失败:', error)
        this.performanceList = []
      } finally {
        this.loading = false
      }
    },

    handleSearch() {
      this.loadPerformanceData()
    },

    handleReset() {
      this.searchYear = '2025'
      this.loadPerformanceData()
    },

    formatAmount(amount) {
      if (amount === null || amount === undefined) {
        return '0.00'
      }
      return Number(amount).toFixed(2)
    },

    async handleExport() {
      try {
        const response = await request.get('/api/consumption/monthly-stats/export', {
          params: {
            year: this.searchYear
          },
          responseType: 'blob'
        })
        
        // 创建下载链接
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `门店业绩统计_${this.searchYear}年.xlsx`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('导出失败:', error)
        alert('导出失败，请重试')
      }
    }
  }
}
</script>

<style scoped>
.store-performance {
  height: 100%;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  font-size: 24px;
  color: #333;
  margin: 0 0 8px 0;
}

.page-header p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.page-content {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 搜索区域样式 */
.search-section {
  margin-bottom: 24px;
}

.search-box {
  display: flex;
  gap: 12px;
  align-items: center;
}

.year-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  min-width: 120px;
}

.year-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.search-btn, .reset-btn, .export-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.search-btn {
  background-color: #007bff;
  color: white;
}

.search-btn:hover {
  background-color: #0056b3;
}

.reset-btn {
  background-color: #6c757d;
  color: white;
}

.reset-btn:hover {
  background-color: #545b62;
}

.export-btn {
  background-color: #28a745;
  color: white;
}

.export-btn:hover {
  background-color: #218838;
}

/* 表格区域样式 */
.table-section {
  margin-bottom: 24px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.table-header h3 {
  font-size: 18px;
  color: #333;
  margin: 0;
}

.table-container {
  overflow-x: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  min-width: 1200px;
}

.data-table th {
  background-color: #f8f9fa;
  color: #333;
  font-weight: 600;
  padding: 12px 8px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 10;
}

.data-table td {
  padding: 12px 8px;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
  text-align: center;
}

.data-row:hover {
  background-color: #f8f9fa;
}

.loading-row, .empty-row {
  text-align: center;
}

.loading-cell, .empty-cell {
  padding: 40px;
  color: #666;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.amount-cell {
  color: #28a745;
  font-weight: 500;
  min-width: 80px;
}

.total-amount-cell {
  color: #dc3545;
  font-weight: 600;
  background-color: #f8f9fa;
  min-width: 100px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .data-table {
    font-size: 12px;
  }
  
  .data-table th,
  .data-table td {
    padding: 8px 4px;
  }
  
  .amount-cell,
  .total-amount-cell {
    min-width: 60px;
  }
}
</style>
